/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { KomboHRSystemDTO } from './kombo-hrsystem-dto';

/**
 * 
 * @export
 * @interface KomboIntegrationStatusDTO
 */
export interface KomboIntegrationStatusDTO {
    /**
     * 
     * @type {string}
     * @memberof KomboIntegrationStatusDTO
     */
    'status'?: KomboIntegrationStatusDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof KomboIntegrationStatusDTO
     */
    'lastSyncStatus'?: KomboIntegrationStatusDTOLastSyncStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof KomboIntegrationStatusDTO
     */
    'id': string;
    /**
     * 
     * @type {KomboHRSystemDTO}
     * @memberof KomboIntegrationStatusDTO
     */
    'hrSystem': KomboHRSystemDTO;
    /**
     * 
     * @type {string}
     * @memberof KomboIntegrationStatusDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof KomboIntegrationStatusDTO
     */
    'lastSyncAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof KomboIntegrationStatusDTO
     */
    'isSyncPending'?: boolean;
}

export const KomboIntegrationStatusDTOStatusEnum = {
    Active: 'ACTIVE',
    InvalidCredentials: 'INVALID_CREDENTIALS',
    SetupIncomplete: 'SETUP_INCOMPLETE',
    Inactive: 'INACTIVE'
} as const;

export type KomboIntegrationStatusDTOStatusEnum = typeof KomboIntegrationStatusDTOStatusEnum[keyof typeof KomboIntegrationStatusDTOStatusEnum];
export const KomboIntegrationStatusDTOLastSyncStatusEnum = {
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED',
    PartiallyFailed: 'PARTIALLY_FAILED',
    AuthenticationFailed: 'AUTHENTICATION_FAILED'
} as const;

export type KomboIntegrationStatusDTOLastSyncStatusEnum = typeof KomboIntegrationStatusDTOLastSyncStatusEnum[keyof typeof KomboIntegrationStatusDTOLastSyncStatusEnum];


